import * as Yup from 'yup'
import _ from 'lodash'



export const ASSET_LABELS = {
    CREATE_ASSET: "Add Asset",
    EDIT_ASSET: "Edit Asset"
};
export const ASSET_TYPES = {
    DOCUMENT: 'Document',
    IMAGE: 'Image',
    EXCEL_SHEET: 'Excel Sheet',
    LINK: 'Link (URL)',
    SLIDE: 'Slide',
    TEXT: 'Text',
    VIDEO: 'Video'
}
// Add this mapping object
export const ASSET_TYPE_MAPPING = {
    'Text': 1,
    'Document': 2,  
    'Excel Sheet': 8,
    'Link (URL)': 4,
    'Slide': 5,
    'Video': 6,
    'Image': 7,
};

// Reverse mapping for API responses
export const ASSET_TYPE_REVERSE_MAPPING = {
    1: 'Text',
    2: 'Document',
    3: 'Document',
    4: 'Link (URL)',
    5: 'Slide',
    6: 'Video',
    7: 'Image',
    8: 'Excel Sheet',
};

 export const assetValidationSchema = Yup.object().shape({
        title: Yup.string()
            .required('Asset title is required'),

        description: Yup.string(),

        task_type: Yup.string()
            .required('Asset type is required'),


     asset_link: Yup.string()
         .nullable() // Allow null values
         .transform((curr, orig) => orig === '' ? null : curr) // Transform empty string to null
         .when('task_type', {
             is: ASSET_TYPE_MAPPING['Link (URL)'], // Compare against the NUMBER value, not string
             then: (schema) => schema
                 .required('URL is required for Link assets')
                 .url('Please enter a valid URL'),
             otherwise: (schema) => schema.notRequired() 
         }),

    })

export const buildAssetPayload = (values, isEditMode) => {
    const payload = {
        task_type: isEditMode ? ASSET_TYPE_MAPPING[values?.task_type] : values?.task_type,
        title: values?.title,
        description: values?.description,
        asset_link: values?.asset_link || null,
        task_column_mapping: values?.task_column_mapping || "custom_task",
        auto_assign_type: values?.auto_assign_type || null
    };

    // Handle files
    if (values?.files?.length > 0) {
        payload.files = values?.files?.map(f => ({ url: f.url || f }));
    }

    if (isEditMode) {
        // Exhibitors
        const exhibitorChanges = categorizeAssetItemChanges(
            values?.exhibitors?.items || [],
            values?.exhibitors?._original || []
        );

        if (hasChanges(exhibitorChanges)) {
            payload.exhibitors = exhibitorChanges;
        }

        // Categories
        const categoryChanges = categorizeAssetItemChanges(
            values?.categories?.items || [],
            values?.categories?._original || []
        );


        // Handle category_ids deletion when switching from categories
        const hadCategoryIds = (values?.category_ids?.length || 0) > 0 &&
            (values?.categories?.items?.length || 0) === 0;

        if (hadCategoryIds && !categoryChanges?.delete_data?.length) {
            categoryChanges.delete_data = (values?.category_ids || [])?.map(id => id?.toString());
        }

        if (hasChanges(categoryChanges)) {
            payload.categories = categoryChanges;
        }

    } else {

        if (values?.exhibitors?.items?.length > 0) {
            const exhibitorData = values?.exhibitors?.items?.map(item => ({
                id: item?.id?.toString()
            }));

            payload.exhibitors = {
                create_data: exhibitorData,
                update_data: [],
                delete_data: []
            };
        }

        //  Categories should also use the same structure
        if (values?.categories?.items?.length > 0) {
            const categoryData = values?.categories?.items?.map(item => ({
                id: item?.id?.toString()
            }));

            payload.categories = {
                create_data: categoryData,
                update_data: [],
                delete_data: []
            };
        }
    }

    return payload;
};

export const categorizeAssetItemChanges = (currentItems, originalItems) => {
    const create_data = [];
    const update_data = [];
    const delete_data = [];

    currentItems = currentItems || [];
    originalItems = originalItems || [];

    const currentIds = currentItems.map(item => item?.id?.toString()).filter(Boolean);
    const originalIds = originalItems.map(item => item?.id?.toString()).filter(Boolean);

    // Deleted items
    delete_data.push(...originalIds.filter(id => !currentIds.includes(id)));

    // New items
    currentIds?.forEach(id => {
        if (!originalIds?.includes(id)) {
            create_data?.push({ id: id });
        }
    });

    return { create_data, update_data, delete_data };
};

const hasChanges = (changes) => {
    if (!changes) return false;
    return (changes?.create_data?.length || 0) > 0 ||
        (changes?.update_data?.length || 0) > 0 ||
        (changes?.delete_data?.length || 0) > 0;
};